module.exports = __webpack_public_path__ + "static/apple-icon-180x180-18d6ee25bd06baf22bc393ba02d4afee.png";